export default "__VITE_PUBLIC_ASSET__4f160b02__"